import React, { ReactElement } from 'react';
import PngTemplateArt from './PngTemplateArt';
import madSadGladImage from '../assets/mad-sad-glad.png';

interface MadSadGladArtProps {
  isDarkMode: boolean;
}

export default function MadSadGladArt({ isDarkMode }: MadSadGladArtProps): ReactElement {
  return <PngTemplateArt src={madSadGladImage} isDarkMode={isDarkMode} />;
}
